<template>
    <div class="email-ipt-wrap">
      <base-input-wrap title="邮箱绑定" :disabled="disabled" :showIptWrap="showIptWrap" @close-ipt-wrap="close" @confirm="confirm">
        <base-input v-model="form.email" ph="输入邮箱" @focus="errMail = ''" :warning="errMail" />
        <p v-if="errMail" class="err">{{errMail}}</p>
        <yz-input
          v-model="form.code"
          scene="email"
          action="bind_email"
          :email="form.email"
          @wrongEmail="errMail = '请输入正确的邮箱'"
          @focus="errCode = ''"
          :errCode="errCode"
        />
        <p v-if="errCode" class="err">{{errCode}}</p>
      </base-input-wrap>
    </div>
</template>

<script>
import baseInputWrap from './base-input-wrap'
import baseInput from './base-input'
import yzInput from './yz-input'

export default {
    data() {
        return {
          showIptWrap: false,
          form: {
            email: '',
            code: ''
          },
          errMail: '',
          errCode: ''
        }
    },
    computed: {
      disabled() {
        return !(this.form.email && this.form.code)
      }
    },
    created() {
      this.emailReg = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;
    },
    methods: {
      open(options = {}) {
        this.form.email = options.email || ''
        this.form.code = ''
        this.errMail = ''
        this.errCode = ''
        this.showIptWrap = true;
      },

      close() {
        this.showIptWrap = false;
        this.form.email = ''
        this.form.code = ''
        this.errMail = ''
        this.errCode = ''
      },

      confirm() {
        if (!this.emailReg.test(this.form.email)) {
          return this.errMail = '请输入正确的邮箱'
        }
        if (this.emailLock) return;
        this.emailLock = true
        this.$fetch.put({
          url: '/user?method=update_email&email=' + encodeURIComponent(this.form.email) + '&code=' + this.form.code
        }).then(data => {
          if (data.success) {
            this.openMessage(1, '更换成功');
            this.close()
            this.$emit('update-user-info');
          }
        }, e => {
          this.errCode = e.error_text || '更换失败'
        })
        .finally(() => setTimeout(() => this.emailLock = false, 500));
      }
    },
    components: {
      baseInputWrap,
      baseInput,
      yzInput
    }
}
</script>

<style lang="scss" scoped>
.email-ipt-wrap {
  position: relative;
  z-index: 100;
}

.err {
  padding: 10px 0 0 4px;
  font-size: 12px;
  color: #E51C23;
}
</style>
